import { has } from "../../../utils/menu-context";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "canEdit" })) {
                result = true || result;
            }
            return result;
        },
    };
};

export const createConditionForm = () => {
    return [
        /* Alway Disable */
        {
            check: ({ field }) => {
                return [
                    "idCard",
                    "refPersonType",
                    "refGender"
                ].includes(
                    field?.key
                );
            },
            inputPropField: () => {
                return  { disabled: true }
            }
        },
        {
            check: ({ field }) => {
                return [
                    "addresses.0.refAddressType",
                    "addresses.1.refAddressType"
                ].includes(
                    field?.key
                );
            },  
            visibleField: ({ data }) => {
                return  "PEOPLE" != data.registerType;
            },
            inputPropField: ({modelRef}) => {
                return modelRef.isOfficer ? { disabled: false }: { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "addresses.0.noTh",
                    "addresses.0.soiTh",
                    "addresses.0.roadTh",
                    "addresses.0.mooTh",
                    "addresses.0.refProvince",
                    "addresses.0.refAmphur",
                    "addresses.0.refTambon",
                    "addresses.0.postCode",
                    "addresses.1.noTh",
                    "addresses.1.soiTh",
                    "addresses.1.roadTh",
                    "addresses.1.mooTh",
                    "addresses.1.refProvince",
                    "addresses.1.refAmphur",
                    "addresses.1.refTambon",
                    "addresses.1.postCode",
                ].includes(
                    field?.key
                );
            },  
            visibleField: ({ data }) => {
                return  "PEOPLE" != data.registerType;
            },
        },
        {
            check: ({ field }) => {
                return [
                    "refRegisterRole",
                    "addresses.0.tel",
                    "addresses.0.email",
                    "addresses.1.tel",
                    "addresses.1.email"
                ].includes(
                    field?.key
                );
            },  
            visibleField: () => {
                return false
            },
            inputPropField: ({ modelRef }) => {
                return modelRef.isOfficer ? { disabled: false }: { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refPersonType"
                ].includes(
                    field?.key
                );
            },
            visibleField: ({ modelRef }) => {
                return !modelRef.isOfficer
            },
        },
        {
            check: ({ field }) => {
                return [
                    "email",
                    "mobile"
                ].includes(
                    field?.key
                );
            },
            inputPropField: ({modelRef}) => {
                return  modelRef.isOfficer ? { disabled: false }: { disabled: true }
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refTitle",
                    "birthDate",
                    "refNationality",
                    "refRace",
                    "refGender",
                    "firstNameTh",
                    "lastNameTh",
                    "idLine",
                    "refEducation",
                    "refMainOccupation",
                    "refSecondOccupation"
                ].includes(
                    field?.key
                );
            },
            visibleField: ({ modelRef }) => {
                return !["1"].includes(modelRef.refPersonType?.key)
            },
            inputPropField: ({modelRef}) => {
                return  modelRef.isOfficer ? { disabled: false }: { disabled: true }
            }
        },
        {
            check: ({ field }) => {
                return [
                    "registerDate","registerCapital","refCompanyType","companyNameTh","shareholdingTh"
                ].includes(
                    field?.key
                );
            },
            visibleField: ({ modelRef }) => {
                return ["1"].includes(modelRef.refPersonType?.key);
            },
            inputPropField: ({modelRef}) => {
                return  modelRef.isOfficer ? { disabled: false }: { disabled: true }
            }
        },
        {
            check: ({ field }) => {
                return [
                    "positionCode",
                    "refPosition",
                    "refDepartment",
                    "refSubDepartment",
                ].includes(
                    field?.key
                );
            },
            visibleField: ({ modelRef }) => {
                return modelRef.isOfficer === true;
            },
            inputPropField: ({modelRef}) => {
                return  modelRef.isOfficer ? { disabled: false }: { disabled: true }
            }
        },
        {
            check: ({ field }) => {
                return [
                    "expireDate"
                ].includes(
                    field?.key
                );
            },
            visibleField: ({ modelRef, data }) => {
                return ["2"].includes(modelRef.refPersonType?.key) || "PEOPLE" === data.registerType;
            },
            inputPropField: ({modelRef}) => {
                return  modelRef.isOfficer ? { disabled: false }: { disabled: true }
            }
        },
        {
            check: ({ field }) => {
                return [
                    "attachmentImageIdCardsLib.0",
                    "attachmentImageSignaturesLib.0"
                ].includes(
                    field?.key
                );
            },
            visibleField: () => {
                return  false;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "attachmentIdCards.0",
                    "attachmentSignatures.0",
                    "attachmentImageIdCards.0",
                    "attachmentImageSignatures.0",
                    "cardIdCard",
                    "cardSignature"
                ].includes(
                    field?.key
                );
            },
            visibleField: ({ modelRef, data }) => {
                return ["2"].includes(modelRef.refPersonType?.key) || "OFFICER" === data.registerType;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "attachmentDocs.0",
                ].includes(
                    field?.key
                );
            },
            visibleField: ({ data }) => {
                return "OFFICER" === data.registerType;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "userRoleRequests"
                ].includes(
                    field?.key
                );
            },
            visibleField: ({ props }) => {
                const { menuContext } = props;
                return has({ menuContext, key: "canApprove" }) ? true : false
            },
            inputPropField: ({modelRef}) => {
                return modelRef.isOfficer != true ? { disabled: true } : {}
            }
        },
        {
            check: ({ field }) => {
                return [
                    "sameAddressType"
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["2"].includes(modelRef.refSameAddressType?.key)
            }
        },
        {
            check: ({ field }) => {
                return [
                    "buttonLinkUser"
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["waitApprove"].includes(modelRef.refStatus?.key)
            },
        },
        {
            check: ({ field }) => {
                return [
                    "spaceIdCard"
                ].includes(field?.key);
            },
            visibleField: ({ modelRef, data, props }) => {
                const { viewOnly } = props;
                return !("1" === modelRef.refPersonType?.key && "FISHERMAN" === data.registerType) && viewOnly
            },
        },
    ];
};
